<template>
  <div class="head">
    <div class="head_in">
      <div class="logo iconfont icon-yiyun">
      </div>
      <div class="info">{{productName}}</div>
    </div>
  </div>
</template>
<script>
  import config from '../apis/config'

export default {
    name: 'logo',
    data () {
      return {
        productName: ''
      }
    },
    created () {
      this.productName = config.productName
    }
}
</script>
<style lang="scss" scoped>
  @import "../assets/css/variable";
.logo{
  padding: 1rem 0 .1rem 0;
  font-size: 1.7rem;
  color: $theme-color;
}
.info{
  font-weight: bold;
  font-size: .40rem;
  color: #e43937;
}
.head{
  font-size: .36rem;
  text-align: center;
  color: #666666;
  background-color: #ecf0f3;
  padding-bottom: .6rem;
}
.mint-button--primary{
  background-color: #E4393C!important;
}
.mintui {
  font-size: .4rem!important;
}
</style>



// WEBPACK FOOTER //
// src/common/logo.vue